(
    function (skyward, $, undefined)
    {
        skyward.familyaccessattendance = skyward.familyaccessattendance || {};

        var WRAPPER_DIV = "familyaccessstudentattendance";
        var btnAttendanceLegend = "#btnStudentAttendanceLegend";

        var init = function (selector)
        {
            var screenSelector = $(selector).find("." + WRAPPER_DIV);
            if (screenSelector.length == 0)
            {
                return;
            }

            $(btnAttendanceLegend).off('click', displayStudentAttendanceLegend).on('click', displayStudentAttendanceLegend);
        };

        skyward.familyaccessattendance.openStudentSectionClassSummaryPanel = function (event)
        {
            var source = $(event.target).closest('a');
            //close the actions menu

            if (source.parents("#studentInformationPopupModal").length < 1)
            {
                skyward.window.closePopup();
            }
            var viewmode = source.data("viewmode") ? source.data("viewmode") : $("#viewmode").val();

            if (!viewmode)
            {
                viewmode = $("#popup0_viewmode").val();
            }

            var screenType = source.data("screentype") ? source.data("screentype") : "";

            if (viewmode == null)
            {
                viewmode = $("input[name='viewmode']").val();
            }

            var data = {
                studentid: source.data("studentid"),
                studentid_securityhash: source.data("studentid_securityhash"),
                studentsectionid: source.data("studentsectionid"),
                studentsectionid_securityhash: source.data("studentsectionid_securityhash"),
                studentsectiontransaction: source.data("studentsectiontransactionid"),
                studentsectiontransactionid_securityhash: source.data("studentsectiontransactionid_securityhash"),
                coursedescription: source.data("coursedescription"),
                coursecode: source.data("coursecode"),
                defaultentityid: source.data("defaultentityid"),
                defaultentityid_securityhash: source.data("defaultentityid_securityhash"),
                parentscreen: source.data("parentscreen"),
                parentscreen_securityhash: source.data("parentscreen_securityhash"),
                ViewMode: viewmode
            };

            skyward.familyaccessattendance.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + screenType + viewmode, data);

            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.familyaccessattendance.openClassSummaryPanel = function (event, action, data)
        {
            var promise = buildClassSummaryPanel(action, data);

            var getClassSummaryContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                }, function ()
                {
                    deferred.reject();
                });

                return deferred.promise();
            };

            var getClassSummaryButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 890,
                id: "classSummaryModal"
            };

            var getClassAndDescription = function ()
            {
                if (data.coursedescription != null)
                {
                    return data.coursedescription + (data.coursecode != null ? " (" + data.coursecode + ")" : "");
                }
                return undefined;
            };

            var classAndDescription = getClassAndDescription();

            skyward.modalLayer.showDialog(classAndDescription == undefined ? "Class Summary" : classAndDescription, getClassSummaryContent, getClassSummaryButtons, options);
        };

        var buildClassSummaryPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentSchedule/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        var displayStudentAttendanceLegend = function () {
            var button = $(this);
            var viewmode = button.data("viewmode");
            var StudentEntityYearIDs = [""];

            var allAttendanceBrowsesID = ".browse[id^='Attendance-']";
            $(allAttendanceBrowsesID).each(function () {
                StudentEntityYearIDs[StudentEntityYearIDs.length] = $(this).attr('id').split('-')[1];
            });

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/StudentAttendance/GetStudentAttendanceLegend" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentEntityYearIDs: JSON.stringify(StudentEntityYearIDs) }
                });
            };

            var beforeClose = function () {
                button.off().on('click', displayStudentAttendanceLegend);
            };

            button.off('click', displayStudentAttendanceLegend);

            var legendTitle = "Attendance Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button, beforeClose: beforeClose });
        };

        skyward.familyaccessattendance.displayCommentPopup = function () {
            var button = $(this);
            var viewmode = button.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();
            var StudentAttendanceID = button.data().id;

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/StudentAttendance/GetStudentAttendanceCommentPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentAttendanceID: JSON.stringify(StudentAttendanceID) }
                });
            };

            var popupTitle = "Comment Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        var events =
        {
            'displayCommentPopup': skyward.familyaccessattendance.displayCommentPopup
        };
        skyward.events.registerEvents('familyaccessattendance', events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);


    }(window.skyward = window.skyward || {}, window.jQuery)
);